import Context from './components/Context';
export * from './icons';
export * from './components/twoTonePrimaryColor';
export { default as createFromIconfontCN } from './components/IconFont';
export { default } from './components/Icon';
var IconProvider = Context.Provider;
export { IconProvider };


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-xui/node_modules/@ant-design/icons/es/index.js
// module id = 2956
// module chunks = 0